import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { border } from '../../layout/theme/border'
import { fadeSlideIn } from './animations'

export const SmallCard = styled(Box)<{ delay: number }>(({ delay }) => ({
  'background': '#fff',
  'borderRadius': border.card.radius,
  'border': '1px solid rgba(0,0,0,0.06)',
  'padding': '20px',
  'animation': `${fadeSlideIn} 0.5s ease-out ${delay}ms both`,
  'transition': 'transform 0.2s ease',
  '&:hover': { transform: 'translateY(-1px)' },
}))
